import React from 'react';
import styled from 'styled-components';
import { getZIndexByLayerName, LayerNames } from '../../constants/layers.constants';
import { LOADING_TEST_ID } from './loading.constants';

const Loading = ({
    backgroundColor,
    display,
    height,
    spinnerSize,
    width,
}) => (
    <Wrapper
        display={display}
        height={height}
        width={width}
        data-testid={LOADING_TEST_ID}
    >
        <LoadingWrapper height={height}>
            <Spinner
                backgroundColor={backgroundColor}
                size={spinnerSize}
            />
        </LoadingWrapper>
    </Wrapper>
);

const Spinner = styled.div`
    animation: cssload-spin 425ms infinite linear;
    -o-animation: cssload-spin 425ms infinite linear;
    -ms-animation: cssload-spin 425ms infinite linear;
    -webkit-animation: cssload-spin 425ms infinite linear;
    -moz-animation: cssload-spin 425ms infinite linear;
    border: 2px solid ${({ backgroundColor }) => backgroundColor || 'rgba(97, 100, 193, 0.98)'};
    border-left-color: transparent;
    border-radius: 50%;
    border-right-color: transparent;
    height: ${({ size }) => size};
    margin: 0 auto;
    width: ${({ size }) => size};
`;

const LoadingWrapper = styled.div`
    align-items: center;
    background-color: transparent;
    display: flex;
    justify-content: center;
    height: ${({ height }) => height};
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    padding: 10px;
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_4)};
`;

const Wrapper = styled.div`
    background-color: transparent;
    min-height: ${({ height }) => height || '100px'};
    width: ${({ width }) => width};
    display: ${({ display }) => display};
`;

Loading.defaultProps = {
    spinnerSize: 30,
    width: '100%',
    backgroundColor: null,
    display: 'block',
};

export default Loading;
